<div
  class="card border-bottom-primary shadow py-1 bloque-2"
  [style.color]="borderBottomColor"
>
  <div class="card-body">
    <div class="row no-gutters align-items-center">
      <div class="col-12 mr-2">
        <div class="text-secondary text-uppercase text-xs mb-1">
          {{ title }}
        </div>
      </div>
      <div class="col-2">
        <i class="fa-xl text-gray-500" [title]="tooltip1" [class]="icon"></i>
      </div>
      <div class="col-6">
        <div class="h4 mb-0 font-weight-bold text-gray-800" [title]="tooltip1" *ngIf="!isLoading">{{ value }}</div>
        <p-skeleton *ngIf="isLoading" />
      </div>
      <div class="col-4 text-right" [title]="tooltip2">
        <svg class="circular-chart" viewBox="0 0 100 100" >
          <!-- Círculo de fondo -->
          <circle class="circle-bg" cx="50" cy="50" r="40"></circle>
          <!-- Círculo de progreso -->
          <circle
            class="circle-progress"
            cx="50"
            cy="50"
            r="40"
            [style.stroke-dashoffset]="strokeDashOffset"
            [style.stroke]="chartProgressColor"
          ></circle>
          <!-- Texto en el centro -->
          <text x="50" y="50" class="percentage-text">{{ chartValue }}</text>
        </svg>
      </div>
    </div>
  </div>
</div>
